/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var PlusIcon20Solid = forwardRef('PlusIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M9.5 2A1.5 1.5 0 0 1 11 3.5V9h5.5a1.5 1.5 0 0 1 0 3H11v5.5a1.5 1.5 0 0 1-3 0V12H2.5a1.5 1.5 0 0 1 0-3H8V3.5A1.5 1.5 0 0 1 9.5 2Z" })));
});
